import {ADD_NOTIFICATION_GROUP, REMOVE_NOTIFICATION_GROUP, SET_NOTIFICATION_GROUP} from '../actions/NotificationGroupsActions';
import initialState from "./initialState";

export default (state = initialState.notificationGroups, action) => {

    const {type, payload} = action;
    switch (type) {
        case SET_NOTIFICATION_GROUP: {
            const {data} = payload;
            return data
        }
        case ADD_NOTIFICATION_GROUP: {
            const {data} = payload;
            return [...state, data]
        }
        case REMOVE_NOTIFICATION_GROUP: {
            const {data} = payload;
            return state.filter( item => item === data)
        }
        default:
            return state;
    }
}
